import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import i18next from 'i18next'

import { setVtcoTwoFactorCode } from '../../actions/localStates'

class TwoFactorConfirmPopup extends Component {

  constructor(props) {
      super(props);
      this.state = {
          secondsLeft: this.props.codeTtl - 1
      };

      this.onTwoFactorCodeChanged = this.onTwoFactorCodeChanged.bind(this);

      this.handle2FKeyUp = this.handle2FKeyUp.bind(this, 'twoFactorInput');
      this.closePopup = this.closePopup.bind(this);
      this.closePopupCancel = this.closePopupCancel.bind(this);
  }

  componentDidMount() {
      this.props.actions.setVtcoTwoFactorCode("");
      var element = document.getElementById("2f");

      if (element !== null) {
        element.focus();
      }
      
      document.addEventListener('keyup', this.handle2FKeyUp);

      this.timer = setInterval(() => {
          this.setState(prev => {
              if (prev.secondsLeft <= 1) {
                  clearInterval(this.timer);
                  this.props.cancelRequest()
                  return { secondsLeft: 0 };
              }

              return {
                  secondsLeft: prev.secondsLeft - 1
              };
          });
      }, 1000);
  }

  componentWillUnmount() {
      document.removeEventListener('keyup', this.handle2FKeyUp);

      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
  }

  handle2FKeyUp(refName, e) {
      if (e.keyCode === 13 && refName === "twoFactorInput") {
          document.getElementById("submitPin").click();
          document.activeElement.blur();
      }
  }

  closePopup () {
    this.props.initAction(this.props.id)
  }

  closePopupCancel () {
    this.props.initAction(true)
    // this.props.actions.setNeed2fConfirm(false);
  }

  onTwoFactorCodeChanged (e) {
    this.props.actions.setVtcoTwoFactorCode(e.target.value)
  }

  cancelLogin2f () {
    this.props.cancelRequest()
    this.props.initAction(true)
  }

  render() {
    let isEnabled = this.props.login.vtcoTwoFactorCode.length >= 6
    ? true
    : false

    let title = this.props.title;

    if (this.props.base.imageFor2F !== null) {
      const qr = this.props.base.imageFor2F.trim();
      var qrToShow;
          qrToShow = qr.startsWith("data:")
              ? qr
              : `data:image/png;base64,${qr}`
    }

      const TOTAL_SECONDS = Math.max(Number(this.props.codeTtl) || 1, 1);

      const radius = 24;
      const circumference = 2 * Math.PI * radius;

      const secondsLeft = Math.max(this.state.secondsLeft, 0);

      // 1.0 -> 0.0
      const progress = secondsLeft / TOTAL_SECONDS;

      // 0 -> circumference
      const dashOffset = circumference * (progress - 1);

      return (
          <div className='popup'>
              <div className="popup_inner_2f">
                <div className="card">
                  <div className="card-header">
                      {i18next.t("confirmLabel")}&nbsp;{i18next.t(title)}
                  </div>
                  <div className="card-body" style={{padding: "1.5rem"}}>
                    
                    {
                      this.props.pkLocalState.isTwoFactorEnable
                      ? <div>
                        {
                          this.props.base.inputTypeFor2F === "image"
                          ? <div style={{textAlign: "center"}}>
                            <img src={qrToShow} style={{
                                  width: "256px",
                                  height: "256px",
                                  display: "block",
                                  margin: "0 auto"
                              }} alt="img" />
                              <label style={{fontSize: "14px"}}>{i18next.t("scanQrMessage")}</label>
                            <p></p>
                            <button id="submit2f" className="btn btn-default" style={{float: "right"}} onClick={this.cancelLogin2f.bind(this)}>{i18next.t("cancelLabel")}</button>
                          </div>
                          : <div>
                                <div className="form-group row" style={{ marginBottom: "0px"}}>
                                  <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                                    <div className="input-group">
                                        <input id="2f" type="text" placeholder={i18next.t("oneTimeCodeTitle")} className="form-control" autoComplete="off" value={this.props.login.vtcoTwoFactorCode} onChange={this.onTwoFactorCodeChanged} />
                                    </div>
                                  </div>
                              </div>
                              {
                                this.props.tries !== undefined && this.props.tries > 0 && this.props.tries < 3
                                ? <label style={{ marginBottom: "0px", paddingTop: "5px"}}>{i18next.t("triesLeft")}{this.props.tries}</label>
                                : null
                              }
                              <p></p>
                              <div style={{paddingTop: "8px"}}>
                                  <button className="btn btn-default" style={{float: "right"}} onClick={this.closePopupCancel}>{i18next.t("cancelLabel")}</button>

                                  <button className="btn btn-default" id="submitPin" style={{float: "right", marginRight: "10px"}} disabled={!isEnabled} onClick={this.closePopup}>{i18next.t("pk:selectTitle")}</button>
                              </div>
                          </div>
                        }
                        {
                          this.props.pkLocalState.isTwoFactorEnable &&
                          <div style={{ position: "absolute", left: 15, bottom: 15 }}>
                              <svg width="60" height="60">
                                <circle
                                    cx="30"
                                    cy="30"
                                    r={radius}
                                    fill="none"
                                    stroke="#ddd"
                                    strokeWidth="4"
                                />
                                <circle
                                    cx="30"
                                    cy="30"
                                    r={radius}
                                    fill="none"
                                    stroke="rgb(17, 45, 106)"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                    transform="rotate(-90 30 30)"
                                    strokeDasharray={circumference}
                                    strokeDashoffset={dashOffset}
                                />
                                <text
                                    x="30"
                                    y="35"
                                    textAnchor="middle"
                                    fontSize="16"
                                    fontWeight="bold"
                                >
                                    {secondsLeft}
                                </text>
                            </svg>
                          </div>
                      }
                      </div>
                      : null
                    }
                    
                  </div>
                </div>
              </div>
          </div>
      );
    }
}

function mapStateToProps(state) {
    return {
        base: state.base,
        pkLocalState: state.privateKeyReducer,
        login: state.privateKeyReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
      setVtcoTwoFactorCode
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TwoFactorConfirmPopup);